import { useContext } from 'react'

import CurrentUserContext from 'contexts/current-user-context'

/** The signed-in user's payload from CurrentUserProvider. */
const useCurrentUser = (): {
  isAdmin: boolean
  data: any
  // Apollo's flag for the `me` query, true while it is in flight.
  loading?: boolean
} => useContext(CurrentUserContext)

export default useCurrentUser
